import PropTypes from "prop-types";
import React from "react";
import { DialogContainer } from "react-md";
import { Card, CardText } from "react-md/lib/Cards";
import { MSpinner } from "components/Shared";
import Button from "react-md/lib/Buttons/Button";
import { Field, change } from "redux-form";
import MultiSelect from "@khanacademy/react-multi-select";
import logo from "static/images/logo.png";
import { InputField, normalizePhone, normalizeZip, normalizeToLen, MSelectField } from "components/FormElements";

class Register extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = "Register";
        this.styleHack = "md-cell md-cell--6 md-inline-block form-multi-select ";
        this.state = {
            formIsSubmitting: false,
            dialog: {
                actions: null,
                visible: false,
                title: "",
                text: ""
            },
            redirect: false,
            blocking: false,
            blockRef: this.props.history.block((location) => this.navBlock(location)),
            availableCompanies: this.props.getAvailableCompanies(),
            selectedCompanies: [],
            styleHack: this.styleHack + " pristine-multiSelect"
        };

        this.showConfirmDialog = () => {
            const actions = [];
            actions.push({ secondary: true, children: "Cancel", onClick: this.hideDialog });
            actions.push(<Button flat primary type="submit" onClick={this.hideDialog}>Confirm</Button>);

            this.showDialog("Submit Registration", `Are you sure?`, actions);
        };

        this.showSubmittingDialog = (title, text, actions) => {
            this.setState({
                dialog: {
                    actions: actions,
                    visible: true,
                    title: title,
                    text: text
                }
            });
        };

        this.showDialog = (title, text, actions) => {
            if (typeof actions === "string") {
                actions = {
                    onClick: this.hideDialog,
                    primary: true,
                    children: actions
                };
            }

            this.setState({
                dialog: {
                    actions: actions,
                    visible: true,
                    title: title,
                    text: text
                }
            });
        };

        this.hideDialog = () => {
            this.setState({
                dialog: {
                    actions: null,
                    visible: false,
                    title: "",
                    text: ""
                }
            });
        };

        //type can be "success" or "error" (and maybe more)
        this.makeToast = (text, type) => {
            this.props.makeToast(text, type);
        };

        const submitFailedMessage = "Please resolve your form errors before submitting, check for any red text or missing//required fields.";

        this.customSubmit = (proxy, event) => {
            this.setState({ formIsSubmitting: true });
            this.showSubmittingDialog("Submitting", <MSpinner />, [{ secondary: true, children: "Close", onClick: this.hideDialog }]);

            let results = this.props.handleSubmit(
                userData => this.props.userRegistration(userData)
            )(proxy, event);

            if (results) {
                this.setState({ formIsSubmitting: false });
                this.hideDialog();
                this.makeToast(submitFailedMessage);
            }

            return results;
        };

        this.UNSAFE_componentWillReceiveProps = (nextProps) => {
            if (!nextProps.isSubmitting && this.state.dialog.visible) {
                this.setState({ formIsSubmitting: false });
                this.hideDialog();
            }

            if (this.props.isFetchingCompanies && !nextProps.isFetchingCompanies) {
                let stateUpdate = {
                    availableCompanies: nextProps.availableCompanies.map(c => {
                        return { value: c.id, label: c.name };
                    })
                };

                this.setState(stateUpdate);
            }
        };

        this.componentDidMount = () => {
            window.addEventListener("beforeunload", this.closeBlock);
            if (!this.props.stateList.length && !this.props.fetchingStateList) {
                this.props.getStateList();
            }
        };

        this.componentWillUnmount = () => {
            this.state.blockRef();
            window.removeEventListener("beforeunload", this.closeBlock);
        };

        this.navBlock = (location) => {
            if (!this.props.submitSuccess) {
                if (location.pathname !== this.props.location.pathname) {
                    return "Are you sure you want to leave this page?";
                }
            }
        };
        this.closeBlock = (e) => {
            if (!this.props.submitSuccess) {
                let confirmationMessage = "\o/";
                (e || window.event).returnValue = confirmationMessage;
                return confirmationMessage;
            } else return null;
        };
        this.navigateHome = () => {
            window.location = "https://www2.muellerreports.com/";
        };

        this.onCompanyFilterChanged = (selected) => {
            let tempStyleHack = "";

            if (selected.length) {
                tempStyleHack = this.styleHack + " dirty-multiSelect";
            }
            else {
                tempStyleHack = this.styleHack + " error-multiSelect";
            }

            this.setState({ selectedCompanies: selected, styleHack: tempStyleHack });
            this.props.dispatch(change("Register", "companySelection", selected));
        };

        this.companyTypeValueRenderer = (selected, options) => {
            if (selected.length === options.length) return "All Companies Selected";
            if (selected.length) return `${selected.length} Selected`;
            return "Select Companies";
        };
    }

    render() {
        if (this.state.redirect) {
            if (window.location.href.includes("webui"))
                window.location.href = "/webui/";
            else
                window.location.href = "/";
        }

        const {
            isFetchingCompanies,
            fetchingStateList,
            stateList
        } = this.props;

        if (fetchingStateList || isFetchingCompanies || !this.state.availableCompanies) {
            return <MSpinner />;
        }


        const email = value =>
            value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ?
                "Invalid email address" : undefined;
        const phone = value =>
            value && value.length < 12 ?
                "Invalid phone number" : undefined;
        const zip = value =>
            value && value.length < 5 ?
                "Invalid zip code" : undefined;
        return (
            <div style={{ height: "100%", backgroundColor: "#fafafa" }}>
                <div className="md-grid md-cell registration-header">
                    <div>
                        <img src={logo} alt="logo.png" className="mueller-logo" />
                        <h3 className="mueller-title" data-test="title">Mortgage Broker Registration</h3>
                    </div>
                </div>
                <div className="case-header registration-form">
                    {
                        this.props.submitSuccess ?
                            <div style={{ textAlign: "center" }}>
                                <p><b style={{ fontSize: "initial" }}>Thank you for registering. Your username is: <h3 style={{ color: "#C8102E" }}>{this.props.username}</h3></b></p>
                                <p><b style={{ fontSize: "initial" }}>You will be receiving an email instructing you to reset your password. Click on the link within the email to reset your password.</b></p>
                                <br />
                                <Button
                                    primary
                                    raised
                                    style={{ marginLeft: "5px" }}
                                    children="Home"
                                    className="m-t-10 save"
                                    onClick={this.navigateHome}
                                />
                            </div> :
                            <form onSubmit={this.customSubmit} ref={form => { this.target = form; }}>
                                <DialogContainer
                                    id="dialog"
                                    visible={this.state.dialog.visible}
                                    title={this.state.dialog.title}
                                    actions={this.state.dialog.actions}
                                    aria-describedby="dialogParagraph"
                                    modal
                                >
                                    <p id="dialogParagraph" className="md-color--secondary-text">
                                        {this.state.dialog.text}
                                    </p>
                                </DialogContainer>
                                <Card className="step-cards">
                                    <CardText>
                                        <div className="md-grid section">
                                            <div className="sub-section">
                                                <Field
                                                    containerClassName="md-cell md-cell--6 md-inline-block"
                                                    id="firstName"
                                                    name="firstName"
                                                    //required
                                                    component={InputField}
                                                    type="text"
                                                    hintText="First Name"
                                                    dataTest="first-name"
                                                    autoComplete="given-name"
                                                    normalize={val => normalizeToLen(val, 50)}
                                                />
                                                <Field
                                                    containerClassName="md-cell md-cell--6 md-inline-block"
                                                    id="lastName"
                                                    name="lastName"
                                                    //required
                                                    component={InputField}
                                                    type="text"
                                                    hintText="Last Name"
                                                    dataTest="last-name"
                                                    autoComplete="family-name"
                                                    normalize={val => normalizeToLen(val, 50)}
                                                />
                                                <Field
                                                    containerClassName="md-cell md-cell--6 md-inline-block"
                                                    id="email"
                                                    name="email"
                                                    //required
                                                    component={InputField}
                                                    validate={email}
                                                    type="text"
                                                    hintText="Email (This will be your username)"
                                                    dataTest="email"
                                                    autoComplete="email"
                                                    normalize={val => normalizeToLen(val, 100)}
                                                />
                                                <Field
                                                    containerClassName="md-cell md-cell--6 md-inline-block"
                                                    id="companyName"
                                                    name="companyName"
                                                    //required
                                                    component={InputField}
                                                    type="text"
                                                    hintText="Company Name"
                                                    dataTest="company-name"
                                                    autoComplete="organization"
                                                    normalize={val => normalizeToLen(val, 100)}
                                                />
                                                <Field
                                                    containerClassName="md-cell md-cell--12"
                                                    id="companyAddress1"
                                                    name="companyAddress1"
                                                    //required
                                                    component={InputField}
                                                    type="text"
                                                    hintText="Address 1"
                                                    dataTest="company-address-1"
                                                    autoComplete="address-line1"
                                                    normalize={val => normalizeToLen(val, 75)}
                                                />
                                                <Field
                                                    containerClassName="md-cell md-cell--12"
                                                    id="companyAddress2"
                                                    name="companyAddress2"
                                                    //required
                                                    component={InputField}
                                                    type="text"
                                                    hintText="Address 2"
                                                    dataTest="company-address-2"
                                                    autoComplete="address-line2"
                                                    normalize={val => normalizeToLen(val, 75)}
                                                />
                                                <Field
                                                    containerClassName="md-cell md-cell--6 md-inline-block"
                                                    id="city"
                                                    name="city"
                                                    //required
                                                    component={InputField}
                                                    type="text"
                                                    hintText="City"
                                                    dataTest="city"
                                                    autoComplete="address-level2"
                                                    normalize={val => normalizeToLen(val, 50)}
                                                />
                                                <Field
                                                    containerClassName="md-cell md-cell--6"
                                                    id="state"
                                                    name="state"
                                                    //required
                                                    component={MSelectField}
                                                    label="State"
                                                    itemLabel="stateName"
                                                    itemValue="stateAbbreviation"
                                                    menuItems={stateList}
                                                    type="text"
                                                />
                                                <Field
                                                    containerClassName="md-cell md-cell--6 md-inline-block"
                                                    id="zip"
                                                    name="zip"
                                                    //required
                                                    component={InputField}
                                                    normalize={normalizeZip}
                                                    validate={zip}
                                                    type="text"
                                                    hintText="Zip"
                                                    dataTest="zip"
                                                    autoComplete="postal-code"
                                                />
                                                <Field
                                                    containerClassName="md-cell md-cell--6 md-inline-block"
                                                    id="phoneNumber"
                                                    name="phoneNumber"
                                                    //required
                                                    component={InputField}
                                                    normalize={normalizePhone}
                                                    validate={phone}
                                                    type="text"
                                                    hintText="Phone Number"
                                                    dataTest="phone-number"
                                                    autoComplete="tel"
                                                />

                                                <Field
                                                    containerClassName="md-cell md-cell--6 md-inline-block"
                                                    id="BrokerIsCorrespondent"
                                                    name="BrokerIsCorrespondent"
                                                    component={MSelectField}
                                                    label="Are you a correspondent lender?"
                                                    itemLabel="label"
                                                    itemValue="value"
                                                    menuItems={["Yes", "No"]}
                                                    type="text"
                                                />



                                                <div className={this.state.styleHack}>
                                                    {/* multiselect doesn't support className so it has to be in it's own div. */}
                                                    <MultiSelect
                                                        id="SelectedCompanyField"
                                                        options={this.state.availableCompanies}
                                                        selected={this.state.selectedCompanies}
                                                        onSelectedChanged={this.onCompanyFilterChanged}
                                                        valueRenderer={this.companyTypeValueRenderer}
                                                        disableSearch
                                                    />

                                                    <Field
                                                        containerClassName="hidden"
                                                        id="companySelection"
                                                        name="companySelection"
                                                        component={InputField}
                                                        type="hidden"
                                                        autoComplete="given-name"
                                                        style={{ width: "300px", height: "0px", "line-height": "0px !important", "border-width": "0px", "text-size": "0px" }}
                                                    />



                                                </div>


                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ width: "100%", textAlign: "right" }} >
                                                <Button
                                                    primary
                                                    raised
                                                    style={{ marginLeft: "5px" }}
                                                    children="Submit"
                                                    className="m-t-10 save"
                                                    data-test="Place-Order"
                                                    disabled={this.state.formIsSubmitting}
                                                    onClick={this.showConfirmDialog}

                                                />
                                            </div>
                                        </div>
                                    </CardText>
                                </Card>
                            </form>
                    }
                </div>
            </div>
        );
    }
}

Register.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    userRegistration: PropTypes.func.isRequired,
    makeToast: PropTypes.func.isRequired,

    isSubmitting: PropTypes.bool.isRequired,
    submitSuccess: PropTypes.bool.isRequired,
    username: PropTypes.string.isRequired,

    history: PropTypes.object,
    location: PropTypes.object,

    getStateList: PropTypes.func.isRequired,
    stateList: PropTypes.array.isRequired,
    fetchingStateList: PropTypes.bool.isRequired,
    getAvailableCompanies: PropTypes.func.isRequired,
    isFetchingCompanies: PropTypes.bool.isRequired,
    dispatch: PropTypes.func
};

export default Register;
